import * as types from "../actions/actionTypes";
import initialState from "./initialState";
import { SessionActions } from "../actions/guideStreamActions";

export default function waitingForSignOffReducer(state = initialState.waitingForSignOff, action: SessionActions) {
    switch (action.type) {
        case types.LOAD_PARTIALLY_COMPLETE_SESSIONS_SUCCESS:
            return action.partiallyCompleteSessions;
        default:
            return state;
    }
}
